export default "__VITE_ASSET__B2DsSwuB__"